<div class="flow-card bg-white border border-gray-200 rounded-lg text-sm">
  <div class="flow-card-header p-3 flex items-center gap-2 bg-gray-100 rounded-t-lg">
    <mat-icon [class]="iconColor()">{{ icon() }}</mat-icon>
    <span class="font-medium flex-1">{{ label() }}</span>
    <ng-content select="[flowCardActions]" />
  </div>
  <div class="flow-card-content p-3 border-t border-inherit [&:not(:has(*))]:hidden">
    <ng-content />
  </div>
</div>
